export function GoogleAnalyticsLogo({ className }: { className?: string }) {
  return (
    <svg
      aria-hidden="true"
      className={className}
      viewBox="0 0 24 24"
      width="24"
      height="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M22 12c0 1.1-.9 2-2 2s-2-.9-2-2V4c0-1.1.9-2 2-2s2 .9 2 2v8z" fill="#F9AB00" />
      <path d="M14 20c0 1.1-.9 2-2 2s-2-.9-2-2v-8c0-1.1.9-2 2-2s2 .9 2 2v8z" fill="#E37400" />
      <circle cx="4" cy="20" r="2" fill="#E37400" />
    </svg>
  );
}
